import React, { useEffect, useRef } from "react";
import "./upcomingEvent.css";
import events from "../../Data/eventsData";

const HomeEvents = () => {
  const carouselRef = useRef(null);

  useEffect(() => {
    const { current } = carouselRef;
    let scrollAmount = 0;
    const maxScroll = current.scrollWidth - current.clientWidth;

    const interval = setInterval(() => {
      if (scrollAmount >= maxScroll) {
        scrollAmount = 0; // reset scroll to start
      } else {
        scrollAmount += 1; // scroll speed
      }
      current.scrollTo({ left: scrollAmount, behavior: "smooth" });
    }, 20); // adjust interval for speed

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="events-container">
      <h2 className="events-title">🔥 Upcoming Events</h2>
      <div className="events-carousel" ref={carouselRef}>
        {events.map((event) => (
          <div key={event.id} className="event-card">
            <span className="event-badge">🔥 Upcoming</span>
            <div className="event-image">
              <img src={event.img} alt={event.title} />
            </div>
            <div className="event-content">
              <h2>{event.title}</h2>
              <p>{event.desc}</p>
              <p className="event-date">📅 {event.date}</p>
              <p className="event-location">📍 {event.location}</p>
             <div className="event-btn-container">
  <a href="/event">
    <button className="event-btn">Explore More</button>
  </a>
</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeEvents;
